import { CoreModel } from '../core/core.model';
/**
 * <h4>Example of Image Model:</h4>
 * <pre>{{'{'}}
 * 	label: 'Cedrus',
 * 	labelPosition: 'bottom',
 *  url: 'https://github.com/Cedrusco/cedrus-fusion-lite/blob/master/src/demo/src/assets/images/journal-mountains.jpg?raw=true'
 * {{'}'}}</pre>
 */
export class ImageModel extends CoreModel {
/**
 * Label on image.
 */
label: string;
/**
 * Label position. Can be: bottom, left, right, top. Default: bottom.
 */
labelPosition: string;
/**
 * Image url with default image.
 */
url: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ImageModel_tsickle_Closure_declarations() {
/**
 * Label on image.
 * @type {?}
 */
ImageModel.prototype.label;
/**
 * Label position. Can be: bottom, left, right, top. Default: bottom.
 * @type {?}
 */
ImageModel.prototype.labelPosition;
/**
 * Image url with default image.
 * @type {?}
 */
ImageModel.prototype.url;
}

